export default class Passo7 {
  constructor(id, listaPlanejamento = [], listaComplementoInformacoes = [],
    listaLiquidacaoManual = []) {
    this.id = id;
    this.listaPlanejamento = listaPlanejamento;
    this.listaComplementoInformacoes = listaComplementoInformacoes;
    this.listaLiquidacaoManual = listaLiquidacaoManual;
  }
}
